import React from 'react';
import styles from "../LocationForm.module.css";
import {CustomInputField} from "../../../../../elements/customInputField/CustomInputField";
import {ValidationResult} from "../../../../../elements/validator/component/ValidationComponent";
import {
    DefaultValidValidator,
    NotEmptyStringValidator,
    PhoneNumberValidator,
    PostcodeValidator
} from "../../../../../elements/validator/Validator";
import {Section} from "../../../../../elements/section/Section";
import {ValidatedInputField} from "../../../../../elements/validator/component/ValidatedInputField";
import {useAppSelector} from "../../../../../../app/hooks";
import {
    LocationFormSelectionProvider,
    LocationRequest,
    LocationRequestPartial,
    WorkingHoursRequest
} from "../LocationForm";

interface Props<T, W> {
    getMessage: (s: any) => any;
    updateRequest: (update: LocationRequestPartial) => void;
    selectionProvider: LocationFormSelectionProvider<W>;
    updateValidationStatus: (status: ValidationResult<T>) => void;
}

export const LocationInformation = <
    T extends LocationRequest,
    W extends WorkingHoursRequest
>({
      getMessage,
      updateRequest,
      selectionProvider,
      updateValidationStatus,
  }: Props<T, W>) => {

    const publicId = useAppSelector(selectionProvider.publicId)

    return <Section title={"Location Details"}>
        <div className={styles.fieldsLine}>
            <CustomInputField
                readOnly={true}
                isRequired={true}
                title={"Public Location ID"}
                value={publicId}
                placeholder={""}
                setValue={() => 123}
            />
            <ValidatedInputField<string, T>
                onChange={(v) => updateRequest({city: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'city'}
                selector={selectionProvider.city}
                validator={NotEmptyStringValidator}
                label={'City'}
                placeholder={"City"}
                getMessage={getMessage}
            />
        </div>
        <div className={styles.fieldsLineWithMargin}>
            <ValidatedInputField<string, T>
                onChange={(v) => updateRequest({name: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'name'}
                selector={selectionProvider.name}
                validator={NotEmptyStringValidator}
                label={'Name'}
                placeholder={"Location name"}
                getMessage={getMessage}
            />
        </div>
        <div className={styles.fieldsLineWithMargin}>
            <ValidatedInputField<string, T>
                onChange={(v) => updateRequest({postcode: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'postcode'}
                selector={selectionProvider.postcode}
                validator={PostcodeValidator}
                label={'Postcode'}
                placeholder={"e.g., AB12 3CD, K1A 0B1, D02 AF30 or 90210"}
                getMessage={getMessage}
            />
            <ValidatedInputField<string, T>
                onChange={(v) => updateRequest({phoneNumber: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'phoneNumber'}
                selector={selectionProvider.phoneNumber}
                validator={PhoneNumberValidator}
                label={'Phone number'}
                placeholder={"e.g., +44 123 4567890 or +1 416 555 0123"}
                getMessage={getMessage}
            />
        </div>
        <div className={styles.fieldsLineWithMargin}>
            <ValidatedInputField<string, T>
                required={false}
                onChange={(v) => updateRequest({locationHash: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'locationHash'}
                selector={selectionProvider.locationHash}
                validator={DefaultValidValidator}
                label={'Location Hash'}
                placeholder={"Optional"}
                getMessage={getMessage}
            />
        </div>
    </Section>
}
